// extracted by mini-css-extract-plugin
export default {"labels":"Lottery_labels__qH00Y"};